import MMatchActionDialog from './MMatchActionDialog.vue';

export { MMatchActionDialog };
export default MMatchActionDialog;
